//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import configuracaoWorkflowContratoResource from '../../common/resources/configuracao/configuracao-workflow-contrato';

import { copyObject } from '../../common/functions/helpers'; // eslint-disable-line

export default {
  name: 'ConfiguracaoWorkflowContrato',
  data() {
    return {
      configuracaoWorkflowContratoResources: configuracaoWorkflowContratoResource(this.$resource),
      contratos: [],
      negociacoes: [],
      configuracoesContrato: [],
      tipoAcordo: '',
      tipoProvisao: '',
      disableCheck: false,
      tipos: [
        { tipo: 'FIXO', descricao: this.$t('label.gasto_fixo') },
        { tipo: 'MARGEM', descricao: this.$t('label.margem') },
      ],
    };
  },
  computed: {
    hasConfiguracoesContrato() {
      return !!(this.configuracoesContrato && this.configuracoesContrato.length);
    },
    grupos() {
      if (this.hasConfiguracoesContrato) {
        const grupos = this._.groupBy(this.configuracoesContrato, el => el.nomeGrupo);
        Object.keys(grupos).forEach((key) => {
          grupos[key] = this._.groupBy(grupos[key], el => el.nomeSubGrupo || 'SEM_SUB_GRUPO');
        });
        return grupos;
      }
      return [];
    },
    contratosCombobox() {
      return this.contratos.length ?
        this.contratos.filter(el => el.valor) :
        [];
    },
  },
  methods: {
    convertToBool() {
      this.contratos.forEach((el) => {
        el.valor = el.valor === 'true';
      });
    },
    copyObject(el) {
      if (el.valor === true) {
        this.contratosCombobox.push(el);
      }
    },
    requestAtualizar(item, $event) {
      if (!this.disableCheck) {
        this.disableCheck = true;
        setTimeout(() => {
          const valorSelecao = $event;
          const nomeAcordo = item.nomeAcordo;
          this.contratosCombobox = [];
          this.contratos.map(this.copyObject);

          this.configuracaoWorkflowContratoResources
            .atualizarTipoAcordo({ valorSelecao, nomeAcordo }, {})
            .then(() => {
              this.disableCheck = false;
              this.$toast.create(this.$t('message.atualizado_confira_tabela'), 'snack', 3E3);
            })
            .catch((err) => {
              this.$error(this, err);
              this.disableCheck = false;
            });
        }, 500);
      }
    },
    requestAtualizarConfiguracao(item, $event) {
      item.valorSelecao = $event;
      delete item.vlrSelecao;

      this.configuracaoWorkflowContratoResources.atualizarConfiguracoesContrato(item)
        .catch((err) => {
          this.$error(this, err);
        });
      this.$forceUpdate();
    },
    requestAtualizarSubConfiguracao(item) {
      if (!this.disableCheck) {
        this.disableCheck = true;
        setTimeout(() => {
          this.configuracaoWorkflowContratoResources.atualizarSubConfiguracoesContrato(item)
            .then(() => {
              this.disableCheck = false;
            })
            .catch((err) => {
              this.disableCheck = false;
              this.$error(this, err);
            });
        }, 500);
      }
    },
    requestAtualizarTipoProvisao() {
      const nomeAcordo = this.tipoAcordo;
      this.configuracaoWorkflowContratoResources
        .atualizarTipoProvisao({ nomeAcordo }, this.tipoProvisao)
        .then(() => {});
    },
    requestPopularTipoProvisao() {
      const nomeAcordo = this.tipoAcordo;
      this.configuracaoWorkflowContratoResources
        .pesquisarTipoProvisao({ nomeAcordo })
        .then((response) => {
          this.tipoProvisao = response.bodyText;
        });
    },
    requestPopular() {
      this.configuracaoWorkflowContratoResources.pesquisar()
        .then((response) => {
          const objeto = response.data;
          if (!objeto || !objeto.length) {
            return;
          }

          this.negociacoes = objeto.filter(el => el.idConfiguracao === 'NEGOCIACOES').map((el) => {
            el.valor = el.valor === 'true';
            return el;
          });

          this.contratos = objeto.filter(el => el.idConfiguracao === 'ACORDO').map((el) => {
            el.valor = el.valor === 'true';
            return el;
          });
          if (this.contratos) {
            this.requestPrimeiroContrato();
          }
        });
    },
    requestPopularConfiguracoesContrato({ nomeAcordo }) {
      this.requestPopularTipoProvisao();

      this.configuracoesContrato = [];
      this.configuracaoWorkflowContratoResources.pesquisarConfiguracoesContrato({ nomeAcordo }, {})
        .then((response) => {
          const objeto = response.data;
          this.configuracoesContrato = objeto.map((el) => {
            el.vlrSelecao = el.valorSelecao === 'true';
            return el;
          });
        });
    },
    requestPrimeiroContrato() {
      if (this.contratosCombobox.length) {
        const selected = this.contratosCombobox[0];
        this.tipoAcordo = selected.nomeAcordo;
        this.requestPopularConfiguracoesContrato(selected);
      }
    },
  },
  mounted() {
    this.requestPopular();
  },
};



// WEBPACK FOOTER //
// ./src/spa/configuracao/ConfiguracaoWorkflowContrato.vue?vue&type=script&lang=js&